//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import { date } from "quasar";
import i18n from "@/i18n/index";
import { APP_DATE_DOT_FORMAT } from "@/assets/js/appConfig";
import { mapActions } from "vuex";
import AQHistory from "@/components/Generics/AQHistory/AQHistory.vue";

export default {
    name: "HistoryItem",
    components: {
        AQCard,
        AQHistory
    },
    props: {
        item: {
            type: Object,
            default: () => ({})
        },
        filters: {
            type: Object,
            default: () => ({
                eventType: null,
                userEmail: null,
                from: null,
                to: null
            })
        }
    },
    data() {
        return {
            itemHistory: []
        };
    },
    methods: {
        ...mapActions("dataStore", [
            "getEntityStructureAudit"
        ]),
        getEntityHistory(open) {
            if (!open) {
                return;
            }
            const payload = {
                entityCode: this.item.entityCode,
                ...this.filters
            };
            this.getEntityStructureAudit(payload).then(data => {
                const types = {
                    D: "delete",
                    T: "delete",
                    U: "edit",
                    I: "create"
                };
                this.itemHistory = data.map(({ actionDescription, modifiedVia, modifiedBy, eventDate, event }) => ({
                    actionDescription,
                    modifiedVia,
                    timeBucket: eventDate,
                    type: types[event],
                    elementName: "",
                    elementId: "",
                    items: [{
                        commitId: "",
                        timestamp: eventDate,
                        userId: "",
                        username: modifiedBy,
                        commitType: types[event],
                        isUserActive: true
                    }]

                }));
            });
        },
        dateFormatter(dateToFormat, withTime) {
            let dateReturn = "";
            const newData = dateToFormat ? date.formatDate(dateToFormat, APP_DATE_DOT_FORMAT).split(".") : "";
            const data = new Date();
            data.setMonth(newData[1] - 1);
            const year = newData[2].split(" ")[0];
            const hour = newData[2].split(" ")[1].substring(0, 5);
            withTime = withTime ? ` ${i18n.t("versioning.at")} ${hour}` : "";
            if (localStorage.getItem("language") === "ro") {
                dateReturn = `${newData[0]} ${data.toLocaleString("ro-RO", { month: "long" })}, ${year}${withTime}`;
            } else {
                dateReturn = `${data.toLocaleString("en-US", { month: "long" })} ${newData[0]}, ${year}${withTime}`;
            }
            return dateReturn;
        }
    }
};
